import type { Props } from './Svg'
import { Svg } from './Svg'

export function ChevronLeftIcon(props: Props) {
  return (
    <Svg width="18" height="18" {...props}>
      <path strokeWidth="2" d="M11.3 4.5 6.7 9l4.5 4.5" />
    </Svg>
  )
}
